module.exports = __webpack_public_path__ + "static/media/home.4dfd9262.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/home.svg
// module id = 1963
// module chunks = 0